"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineReducers = void 0;
const redux_1 = require("redux");
function combineReducers(reducers) {
    if (Object.keys(reducers).length === 0) {
        return (state) => state;
    }
    return redux_1.combineReducers(reducers);
}
exports.combineReducers = combineReducers;
